/**
 * mc-semana-belga.js — Semana Belga (task 0042)
 *
 * JS minimo e feature-detected da pagina da colecao semana-belga:
 * auto-submit do <select> de ordenacao ([data-sb-sort] dentro de
 * [data-sb-sort-form]). Sem JS, o <noscript> exibe o botao "Ordenar"
 * e o form GET nativo faz o mesmo caminho (fail-open).
 *
 * Nao ha mais nada de JS nesta pagina: seletor de estilos, chips e
 * paginacao sao navegacao server-side; o quick-add do card e global
 * (mc-quick-add.js via theme.liquid).
 */
(function () {
  'use strict';

  function init() {
    var selects = document.querySelectorAll('[data-sb-sort]');
    if (!selects.length) return;
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('[data-sb-sort-form]');
        if (form) form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
